module.exports = __webpack_public_path__ + "media/images/icons/dollar-slash-358132732473df349114066680b4c3bd.svg";